import { render, staticRenderFns } from "./PreviewCode.vue?vue&type=template&id=c0c9b0d4&scoped=true"
import script from "./PreviewCode.vue?vue&type=script&lang=js"
export * from "./PreviewCode.vue?vue&type=script&lang=js"
import style0 from "./PreviewCode.vue?vue&type=style&index=0&id=c0c9b0d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c9b0d4",
  null
  
)

export default component.exports